import React from 'react'
import { RegistrationPreset } from '~/models'
import { memo } from '~/ui/component'
import { DataGrid, HBox, Label, SVG } from '~/ui/components'
import { ResourceListScreen } from '~/ui/resources/collection'
import { layout, useStyling } from '~/ui/styling'
import RegistrationPresetForm from '../RegistrationPresetForm'

const RegistrationPresetsScreen = memo('RegistrationPresetsScreen', () => {

  const {colors} = useStyling()

  //------
  // Rendering

  function render() {
    return (
      <ResourceListScreen
        Model={RegistrationPreset}
        CreateFormComponent={RegistrationPresetForm}
        defaultSort='name'
      >
        <DataGrid.Column
          name='name'
          sort={true}
          renderCell={renderName}
          flex={2}
        />
      </ResourceListScreen>
    )
  }

  function renderName(preset: RegistrationPreset) {
    return (
      <HBox gap={layout.padding.s}>
        <SVG
          name={preset.$icon}
          size={layout.icon.m}
          color={colors.semantic.primary}
        />
        <Label bold>
          {preset.name}
        </Label>
      </HBox>
    )
  }

  return render()

})

export default RegistrationPresetsScreen